export default __webpack_public_path__ + "static/media/serviceDemoImage.e219e249.png";